import React, { Component } from 'react';
import { Container, Row, Col} from 'react-bootstrap'
import { SideBar } from '../../components/CustomSidebar';
import axios from 'axios';
//import 'sdk'

export default class Engage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            authResponse :'',
            permissions :[]
        }
        const FB = window.FB;
        FB.init({
            appId            : '281814379634072',
            autoLogAppEvents : true,
            xfbml            : true,
            version          : 'v8.0'
          });
          this.login =this.login.bind(this);
        
    
           FB.getLoginStatus(function(response){
           console.log("status",response)
           });
           FB.api('/113124472034820', function(response) {
            console.log(response);
          });
          this.login = this.login.bind(this)
          this.permissions = this.permissions.bind(this)
    }
    login = ()=>{
        const FB = window.FB;
        FB.login(function(response){
            if(response.status==="connected"){
                console.log('connected');
                console.log(response);
                // this.setState({authResponse:response?.authResponse})
            } else if(response.status==="not_authorized"){
                console.log('not_authorized');
            } else{
                console.log('Unknown error');
            }
        },{
            scope: 'email,pages_show_list,pages_messaging', 
            return_scopes: true,
            auth_type: 'rerequest'
        });
      
    }
    customLogin(){
        var app_id = 281814379634072
        var redirect_uri= 'https://www.facebook.com/connect/login_success.html'
        var state = "{st=state123abc,ds=123456789}"

        axios.get(`https://www.facebook.com/v8.0/dialog/oauth?
        client_id=${app_id}&redirect_uri=${redirect_uri}&state=${state}`)
        .then(res => {
            console.log("response:",res)
        //   const persons = res.data;
        //   this.setState({ persons });
        })

    }

     testAPI() {      
        const FB = window.FB;                // Testing Graph API after login.  See statusChangeCallback() for when this call is made.
        console.log('Welcome!  Fetching your information.... ');
        FB.api('/me', function(response) {
          console.log('response: ' + response);
          console.log('Successful login for: ' + response.name);
          document.getElementById('status').innerHTML =
            'Thanks for logging in, ' + response.name + '!';
        });
      }
      permissions = ()=>{  
        const FB = window.FB;  
        FB.api('/308831593806833/permissions', function(response) {
            console.log(response);
            //this.setState({permissions:response.data})
          });
      }

      getAccount = ()=>{  
        const FB = window.FB;  
        FB.api('/me/accounts', function(response) {
            console.log(response);
            //this.setState({permissions:response.data})
          });
      }


      requestPermission = () => {

        const FB = window.FB;  

        FB.ui({method: "permissions.request", "perms": 'pages_show_list,pages_messaging'} , function(response) { 
            
            console.log(response); });


      }

    
    render() {
        return (
            <Container className={"flex-container-center pt-2 pb-2 d-sm-flex flex-column"} fluid>
                <Row className="gs-inner-container right-border-radius flex-fill scrollable">

                    <Col className="p-0 m-2 ">
                        <p>Permissions</p>
                        <div id='fb-root'>

                <button onClick={this.login}>Login</button>
                <button onClick={this.customLogin}>Custom Login</button>
                <button onClick={this.testAPI}>Test</button>
                <button onClick={this.requestPermission}>Request permission</button>
                <button onClick={this.getAccount}>Account details</button>
                
                <button onClick={() => this.permissions()}>permissions</button>
                <div className="fb-login-button" data-max-rows="1" data-size="medium" data-button-type="login_with" data-show-faces="false" data-auto-logout-link="true" data-use-continue-as="false"></div>
            </div>
            <div id='fb-root'></div>

                    </Col>
                </Row>
            </Container>
        )
    }
}